export const PAGE_STATUS_DRAFT = 'draft';
export const PAGE_STATUS_PUBLISHED = 'published';
export const PAGE_STATUS_UNPUBLISHED = 'unpublished';
export const ACTION_SAVE = 'SAVE';
export const ACTION_SAVE_AND_CONFIGURE = 'SAVE_AND_CONFIGURE';

export const SEO_ENABLED = true;
export const HOMEPAGE_CODE = 'homepage';

export const PAGE_MOVEMENT_OPTIONS = {
  INTO_PARENT: 'INTO_PARENT',
  ABOVE_SIBLING: 'ABOVE_SIBLING',
  BELOW_SIBLING: 'BELOW_SIBLING',
};
